import { inject } from '@angular/core';
import { CanMatchFn, Router, Routes } from '@angular/router';
import { AuthService } from '../../core/auth/services/auth.service';
import { BusinessNotificationsService } from './business-notifications.service';

export const notificationGuard: CanMatchFn = () => {
  const auth = inject(AuthService);
  return auth.isLoggedIn && !!auth.organizationId ? true : inject(Router).parseUrl('/login');
};
const companyAdminGuard: CanMatchFn = () => inject(BusinessNotificationsService).isCompanyAdmin
  ? true : inject(Router).parseUrl('/notifications');
const page = () => import('./notification.page').then(m => m.NotificationPage);
export const notificationRoutes: Routes = [
  {path: '', pathMatch: 'full', loadComponent: page, data: {mode: 'inbox'}},
  {path: 'settings', canMatch: [companyAdminGuard], loadComponent: page, data: {mode: 'settings'}},
  {path: 'history', canMatch: [companyAdminGuard], loadComponent: page, data: {mode: 'history'}},
];
